import { BaseModel } from "sjs-base-model";
import CercaSimulazioneTabellaModel from "./CercaSimulazioneTabellaModel";

export default class CercaSimulazioneModel extends BaseModel {
    public readonly data: CercaSimulazioneTabellaModel[] = [];
    public readonly pageNumber: number = 0;
    public readonly pageSize: number = 0;
    public readonly totalPages: number = 0;
    public readonly totalRecords: number = 0;

    constructor(data: Partial<CercaSimulazioneModel>) {
        super();

        this.update(data);
    }
}
